/**
 * Is the interface currently rendered in dark mode?
 *
 * The `dark` class lives on <html>, set server-side for the `light`/`dark` modes
 * and by the pre-paint script in partials/theme-mode.blade.php for `system`.
 * Read it here rather than from <body> so every consumer agrees on one source.
 */
export function isDarkMode() {
  return document.documentElement.classList.contains('dark')
}
